import React from 'react'
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'react-router-redux'
import store, {history} from './store'
import App from './containers/App'

import {persistStore} from 'redux-persist'
import {asyncSessionStorage} from 'redux-persist/storages'

const target = document.querySelector('#root')

persistStore(store, {blacklist: ["routing"], storage: asyncSessionStorage}, () => {
    render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <div>
                    <App/>
                </div>
            </ConnectedRouter>
        </Provider>,
        target
    )
})



// WEBPACK FOOTER //
// ./src/index.js